export default {
  navigate: {
    id: 'pagination_navigate',
    defaultMessage: 'Navigate to page {page}',
  },
  nextAriaLabel: {
    id: 'pagination_next_aria_label',
    defaultMessage: 'Next page',
  },
  pagination: {
    id: 'pagination_label',
    defaultMessage: 'Product list pagination',
  },
  previousAriaLabel: {
    id: 'pagination_previous_aria_label',
    defaultMessage: 'Previous page',
  },
}
